const baseURL = 'https://filoniauto.com/';

export default baseURL;
